import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'booking_cancellation_trip_management';
export const route = 'booking_cancellation/trip_management/[[...primeFreeCancellationParams]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../../components/TripManagementPage')));